"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["ThreeDS"] = "3ds";
    PaymentStatus["Canceled"] = "canceled";
    PaymentStatus["Authorized"] = "authorized";
    PaymentStatus["Captured"] = "captured";
    PaymentStatus["Refunded"] = "refunded";
    PaymentStatus["Refused"] = "refused";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
exports.default = { PaymentStatus: PaymentStatus };
//# sourceMappingURL=Payment.js.map